/**
 * src/pages/ArchitectureOfKnowledge/ArchitectureOfKnowledge.tsx
 * The Architecture of Knowledge — Hub Page
 *
 * Implements:
 * 1. Cinematic skippable opening with progressive questions & space constellation network
 * 2. Interactive Knowledge Map of the 15 fundamental inquiry areas with dual map/list view
 * 3. Three exploration paths (Guided, Free, Practical) connected to progress store
 * 4. Phase One curriculum overview with substantive task descriptions
 * 5. Epistemic status key & core investigative principles
 * 6. Simulation Theory philosophical bridge
 * 7. Comprehensive related links & master glossary portal
 */

import React from "react";
import { KnowledgePageShell } from "@/components/knowledge/KnowledgePageShell";
import { CinematicOpening } from "./sections/CinematicOpening";
import { KnowledgeMap } from "./sections/KnowledgeMap";
import { ThreeExplorationPaths } from "./sections/ThreeExplorationPaths";
import { PhaseOneOverview } from "./sections/PhaseOneOverview";
import { HowWeLabelClaims } from "./sections/HowWeLabelClaims";
import { SimulationTheoryBridge } from "./sections/SimulationTheoryBridge";
import { FinalReferenceSection } from "./sections/FinalReferenceSection";
import "./architectureOfKnowledge.css";
export default function ArchitectureOfKnowledgePage() {
  return <KnowledgePageShell pageId="hub" character="hub" accent="cyan" className="aok-page">
      {/* 1. Cinematic Skippable Opening */}
      <CinematicOpening />

      <div className="w-full max-w-[76rem] mx-auto px-4 sm:px-6 lg:px-8 space-y-20 sm:space-y-28 py-10 sm:py-16 min-w-0">
        {/* 2. The Knowledge Map */}
        <KnowledgeMap />

        {/* 3. Three Ways to Explore */}
        <ThreeExplorationPaths />

        {/* 4. What's Inside Phase One */}
        <PhaseOneOverview />

        {/* 5. How We Label Claims */}
        <HowWeLabelClaims />

        {/* 6. Connecting to Simulation Theory */}
        <SimulationTheoryBridge />

        {/* 7. Master Glossary & Final Links */}
        <FinalReferenceSection />
      </div>
    </KnowledgePageShell>;
}